import { useDispatch, useSelector } from "react-redux";
import PurchaseBulkOrderHeader from "./PurchaseBulkOrderHeader";
import { getBulkOrderExcelData } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import { useEffect, useState } from "react";
import { CONSTANTS } from "client/utils/constants";

const PurchaseBulkOrderHeaderContainer = (props?: any) => {
    const {
        itemDetails
    } = props

    const dispatch = useDispatch();
    const [headerVendorDetails, setHeaderVendorDetails] = useState<any>({});

    useEffect(() => {
      if(!itemDetails?.isVendorChanged && itemDetails?.isVendorSaved && itemDetails?.vendorDetails?.vendorName){
        setHeaderVendorDetails(itemDetails?.vendorDetails)
      }
    },[itemDetails])

    const isPOCreatedForAllItems = (itemDetails?.fleetRequests?.every((asset: any) => asset?.poNumber !== null) || itemDetails?.purchaseDetails?.items?.every((item: any) => item?.status === CONSTANTS.PO_STATUS.COMPLETE))
    
    const onExportExcel = (e:any,orderDetailId: any) => {
        e.stopPropagation()
        if (orderDetailId && isPOCreatedForAllItems && !itemDetails?.isNonConsolidatedPOCreated) {
            dispatch(getBulkOrderExcelData(orderDetailId));
        }
    }

    return (<PurchaseBulkOrderHeader
        itemDetails={itemDetails}
        onExportExcel = {onExportExcel}
        headerVendorDetails = {headerVendorDetails}
        isPOCreatedForAllItems={isPOCreatedForAllItems}
    />)
}

export default PurchaseBulkOrderHeaderContainer;